// extracted by mini-css-extract-plugin
export default {"logout-template":"styles_logout-template__TXaFf"};